<template>
    <div class="pt-[20px] bg-[#ededed]">
        <div class="w-full container mx-auto max-w-[1400px]">
            <div class="pt-[60px] pr-[20px] pb-[2%] pl-[10px] max-w-[1400px]">
                <greyZone />
            </div>
        </div>
    </div>
    <div class="max-w-[1400px] w-full container mx-auto">
        <div class="pt-[60px] pr-[20px] pb-[40px] pl-[10px] max-w-[1400px] text-center">
            <whiteZone />
        </div>
    </div>
</template>

<script lang="js">
    import { defineComponent } from 'vue'
    import fetchModel from '@/Model.js'
    import sourceData from '@/components/MockJSONFiles (temp)/MockJSONTimesheetFile.json' // MOCK JSON file
    import greyZone from '@/components/Timesheet/TimesheetHeader.vue'
    import whiteZone from '@/components/Timesheet/TimesheetBody.vue'

    export default defineComponent({
        data() {
            return {
                screenWidth: window.innerWidth,
            }
        },

        components: {
            greyZone,
            whiteZone,
        },

        async mounted() {
            window.scrollTo(0, 0)
            window.addEventListener('resize', this.getDimensions)
            // TODO: remove, just here to check the idea that we fetch when component is mounted
            // and redirect to login if unauthorized
            // let users = await fetchModel({method: "GET", endpoint: "offers"});
        },

        methods: {
            getDimensions() {
                this.screenWidth = document.documentElement.clientWidth
            },
        },
    })
</script>
